import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "meetOwner"
const MeetOwnerIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.754 4.509c-.468 0-.468 0-.682.214l-.643.643c-.215.214-.322.321-.322.428 0 .107.107.214.322.429l.856.856.857-.857.857.857.877-.876.856.857.838-.838.857.857.426-.002c.43 1.287 1.93 1.93 4.5 1.93 1.286 0 2.357-.643 2.357-3.213 0-2.57-1.071-3.213-2.358-3.215-2.57-.003-4.069.644-4.497 1.93H9.754ZM20.78 5.74a1.04 1.04 0 1 1-2.08 0 1.04 1.04 0 0 1 2.08 0ZM2 20.91h2.763V10H2v10.91Zm18.895-4.96h-6.407c-.637 0-1.27-.101-1.875-.3l-1.287-.424.348-.932c1.226.44 2.518.665 3.82.665h1c.685 0 1.243-.526 1.243-1.17 0-.486-.326-.923-.81-1.101L9.283 10H6.421v8.945l4.955 1.856a8 8 0 0 0 6.283-.288L23 17.933c-.01-1.09-.937-1.983-2.105-1.983Z"
          />
        </svg>
      }
    </span>
  )
}
export default MeetOwnerIcon
